import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown } from 'lucide-react';
import MatrixRain from './MatrixRain';

const HeroSection = () => {
  const [displayedText, setDisplayedText] = useState('');
  const fullName = 'ORELLANA';

  const audioRef = useRef(null);
  const audioEnabled = useRef(false);

  // useEffect(() => {
  //   let currentIndex = 0;
  //   //const audio = new Audio("/sounds/tecla.mp3");
  //   const typingInterval = setInterval(() => {
  //     if (currentIndex <= fullName.length) {
  //       setDisplayedText(fullName.slice(0, currentIndex));
  //       if (audioEnabled.current && currentIndex > 0) {
  //       const audio = audioRef.current;
  //       audio.currentTime = 0;
  //       audio.play().catch(() => {});
  //     }
  //       currentIndex++;
  //     } else {
  //       clearInterval(typingInterval);
  //     }
  //   }, 450);

  //   return () => clearInterval(typingInterval);
  // }, []);

  // 👉 ESTE useEffect VA AQUÍ
  useEffect(() => {

    audioRef.current = new Audio("/sounds/tecla.wav");

    const enableAudio = () => {
      audioEnabled.current = true;
      document.removeEventListener("click", enableAudio);
    };

    document.addEventListener("click", enableAudio);

  }, []);
  useEffect(() => {

    const startTyping = () => {

      let currentIndex = 0;

      const audio = new Audio("/sounds/tecla.wav");

      const typingInterval = setInterval(() => {

        if (currentIndex <= fullName.length) {

          setDisplayedText(fullName.slice(0, currentIndex));

          if (currentIndex > 0) {
            audio.currentTime = 0;
            audio.play().catch(() => { });
          }

          currentIndex++;

        } else {
          clearInterval(typingInterval);
        }

        //}, 450);
      }, 120 + Math.random() * 80);
      document.removeEventListener("click", startTyping);

    };

    document.addEventListener("click", startTyping);

  }, []);
  // 👉 TU EFECTO DE TYPING (modificado) este hace el ruido solo cuando hago un clickm pero sino escribe todo
  // useEffect(() => {

  //   let currentIndex = 0;

  //   const typingInterval = setInterval(() => {

  //     if (currentIndex <= fullName.length) {

  //       setDisplayedText(fullName.slice(0, currentIndex));

  //       if (audioEnabled.current && currentIndex > 0) {
  //         const audio = audioRef.current;
  //         audio.currentTime = 0;
  //         audio.play().catch(() => { });
  //       }

  //       currentIndex++;

  //     } else {
  //       clearInterval(typingInterval);
  //     }

  //   }, 450);

  //   return () => clearInterval(typingInterval);

  // }, []);


  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Matrix Rain Background */}
      <MatrixRain highlightWord="ORELLANA" />

      {/* Content */}
      <div className="relative z-10 text-center px-4">
        <div className="mb-12">
          <span className="text-green-400 font-mono text-lg tracking-widest">{'>'} Iniciando sistema...</span>
        </div>

        <p className="text-2xl md:text-3xl text-green-400 font-mono tracking-wide mb-2">
          Pedro Gustavo
        </p>

        <h1 className="text-6xl md:text-8xl font-bold mb-6 font-mono tracking-wider">
          <span className="text-green-400 animate-pulse">{displayedText}</span>
          <span className="text-green-400 animate-pulse">_</span>
        </h1>

        <p className="text-2xl md:text-3xl text-gray-300 mb-4 font-mono">
          Licenciado en Informática
        </p>

        <p className="text-lg md:text-xl text-gray-400 mb-12 font-mono max-w-4xl mx-auto leading-relaxed">
          "Al mundo ya no lo dominan las armas, las bombas, ni las guerras.<br />
          Ahora lo dominan un conjunto de unos y ceros llamados bits,<br />
          el que domine la información, dominará al mundo."
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => document.getElementById('contacto').scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-4 bg-green-500 text-black font-mono font-bold rounded hover:bg-green-400 transition-all transform hover:scale-105 shadow-lg shadow-green-500/50"
          >
            CONTACTAR
          </button>
          {/* <button
            onClick={() => document.getElementById('servicios').scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-4 bg-green-500 text-black font-mono font-bold rounded hover:bg-green-400 transition-all transform hover:scale-105 shadow-lg shadow-green-500/50"
          >
            SERVICIOS
          </button>

          <button
            onClick={() => document.getElementById('sobre-mi').scrollIntoView({ behavior: 'smooth' })}
            //className="px-8 py-4 border-2 border-green-500 text-green-400 font-mono font-bold rounded hover:bg-green-500/10 transition-all"
            className="px-8 py-4 bg-green-500 text-black font-mono font-bold rounded hover:bg-green-400 transition-all transform hover:scale-105 shadow-lg shadow-green-500/50"
          >
            SOBRE MÍ
          </button>
          <button
            onClick={() => document.getElementById('formacion').scrollIntoView({ behavior: 'smooth' })}
            //className="px-8 py-4 border-2 border-green-500 text-green-400 font-mono font-bold rounded hover:bg-green-500/10 transition-all"
            className="px-8 py-4 bg-green-500 text-black font-mono font-bold rounded hover:bg-green-400 transition-all transform hover:scale-105 shadow-lg shadow-green-500/50"
          >
            FORMACIÓN
          </button> */}
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={() => document.getElementById('sobre-mi').scrollIntoView({ behavior: 'smooth' })}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-green-400 animate-bounce cursor-pointer"
      >
        <ChevronDown size={40} />
      </button>
    </section>
  );
};

export default HeroSection;